import { inject, Injectable } from '@angular/core';
import { concatMap, map, Observable, of, tap } from 'rxjs';
import { StorageService } from '@src/app/modules/auth';
import { StorageKeys } from '@src/constants/storage';

import { DEFAULT_CITY } from '../../search-cities/city-switcher/constants';

import { LpUserProfileService } from './lp-user-profile.service';

@Injectable({
  providedIn: 'root',
})
export class LpInitialService {
  private readonly lpUserProfileService = inject(LpUserProfileService);
  private readonly storageService = inject(StorageService);

  private readonly authUser$ = this.lpUserProfileService.authUser$;

  init() {
    return this.showCityDialog().pipe(concatMap(() => this.showFavoriteCategoriesDialog()));
  }

  private showCityDialog(): Observable<null> {
    if (this.authUser$.value?.cityId) {
      return of(null);
    }

    // TODO start: Удалить через 2 месяца
    const cityStringify = this.storageService.getItem(StorageKeys.City);
    const storageCity = cityStringify ? JSON.parse(cityStringify) : undefined;

    if (storageCity) {
      return this.lpUserProfileService.updateUserCity(storageCity).pipe(
        map(() => {
          return null;
        }),
      );
    }
    // TODO end

    return this.lpUserProfileService.cityDialog.pipe(
      tap({
        complete: () => {
          if (!this.authUser$.value?.city) {
            this.lpUserProfileService.updateUserCity(DEFAULT_CITY).subscribe();
          }
        },
      }),
      map(() => {
        return null;
      }),
    );
  }

  private showFavoriteCategoriesDialog() {
    const isFirstLoyaltyLogin = !this.storageService.getItem(StorageKeys.FirstLoyaltyLogin);

    if (!isFirstLoyaltyLogin) return of();

    return this.lpUserProfileService.showFavoriteCategoriesDialog(this.authUser$.value?.favoriteCategories).pipe(
      tap({
        complete: () => {
          this.storageService.setItem(StorageKeys.FirstLoyaltyLogin, new Date().toDateString());
        },
      }),
      concatMap(favoriteCategoriesIds => {
        if (!favoriteCategoriesIds?.length) return of();

        return this.lpUserProfileService.updateUserFavoriteCategories(favoriteCategoriesIds).pipe(
          map(() => {
            return;
          }),
        );
      }),
    );
  }
}
